<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>Bill Submit</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Bill Submit</ion-title>
        </ion-toolbar>
      </ion-header>
    
      <div id="container">
        <ion-item>
          <ion-label position="floating">Bill Type <span class="required">*</span></ion-label>
          <ion-select mode="ios" interface="action-sheet" v-model="billType">
              <ion-select-option value="Logistics">Logistics</ion-select-option>
              <ion-select-option value="Marketing">Marketing</ion-select-option>
              <ion-select-option value="Admin">Admin</ion-select-option>
              <ion-select-option value="Sales">Sales</ion-select-option>
              <ion-select-option value="Other">Other</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Date <span class="required">*</span></ion-label>
            <ion-datetime  v-model="date" presentation="date"></ion-datetime>
        </ion-item>
        <ion-list>
            <ion-item v-for="(head,i) of visualExpenseData" :key="i">
                <ion-label>
                    <strong>Expense Head:</strong> {{head['expenseName']}} <br>
                    <ion-text v-for="d in Object.keys(head)" :key="d">
                        <template v-if="d!='expenseName' && d!='expense_head_id' && d!='attachments'">
                        <strong>{{d}}:</strong> {{head[d]}} <br>
                        </template>
                    </ion-text>
                    <ion-item v-for="(attacment, i) of head['attachments']" :key="i">
                        <ion-img :src="'data:image/jpeg;base64,'+attacment"></ion-img>
                    </ion-item>
                </ion-label>
            </ion-item>
        </ion-list>
        <ion-button id="trigger-button" @click="isModalOpen=true">Add Expense</ion-button>
        <ion-modal :is-open="isModalOpen" trigger="trigger-button">
            <ion-page>
                <ion-header>
                <ion-toolbar mode="ios">
                    <ion-buttons slot="end">
                    <ion-button @click="isModalOpen=false; expenseHead=''; attachmentTmp=[]">Cancel</ion-button>
                    </ion-buttons>
                    <ion-title>Add Expense</ion-title>
                </ion-toolbar>
                </ion-header>
                <ion-content :fullscreen="true">
                    <ion-item>
                        <ion-label position="floating">Expense Head<span class="required">*</span></ion-label>
                        <ion-select mode="ios" interface="action-sheet" v-model="expenseHead">
                            <ion-select-option v-for="(expenseHead,i) of expenseHeads" :key="i" :value="expenseHead">{{expenseHead.name}}</ion-select-option>
                        </ion-select>
                    </ion-item>
                    <div v-if="expenseHead!=''">
                        <ion-item v-for="(field,i) of JSON.parse(expenseHead.fields)" :key="i">
                            <ion-label position="floating">{{field.name}}<span class="required">*</span></ion-label>
                            <ion-input v-if="field.type!='Date'" :type="field.type.toLowerCase()" v-model="expenseDataTmp[field.name]"></ion-input>
                            <ion-datetime v-else  v-model="expenseDataTmp[field.name]" presentation="date"></ion-datetime>
                        </ion-item>
                        <ion-item>
                            <ion-label position="floating">Total Amount<span class="required">*</span></ion-label>
                            <ion-input type="number" v-model="expenseDataTmp['TotalAmount']"></ion-input>
                        </ion-item>
                        <ion-item v-for="(attacment, i) of attachmentTmp" :key="i">
                            <ion-img :src="'data:image/jpeg;base64,'+attacment"></ion-img>
                        </ion-item>
                        <ion-item>
                            <ion-button @click="takePicture()" color="primary">Take Picture</ion-button>
                        </ion-item>
                        <ion-button @click="addExpense" color="primary">Add Expense</ion-button>
                    </div>
                </ion-content>
            </ion-page>
        </ion-modal>
        <ion-button expand="block" @click="save" color="success">Submit</ion-button>
        
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonButtons, IonContent, IonHeader, IonText, IonMenuButton, IonPage, IonTitle, IonToolbar, IonButton, IonItem, IonLabel, IonInput, IonList, IonSelect, IonSelectOption, alertController, IonDatetime, IonModal} from '@ionic/vue';
import { Camera, CameraResultType } from '@capacitor/camera';
export default {
  name: 'Bill Submit',
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    IonItem,
    IonLabel,
    IonInput,
    IonSelect,
    IonSelectOption,
    IonDatetime,
    IonModal,
    IonList,
    IonText
  },
  created(){
    this.$http.get('getExpenseHeads',).then(response=>{
        this.expenseHeads=response.data;
    });
  },
  data(){
      return {
        isModalOpen:false,
        billType:null,
        visualExpenseData:[],
        expenseData:[],
        expenseDataTmp:{},
        attachmentTmp:[],
        date:null,
        users:[],
        submitTo:null,
        expenseHead:'',
        expenseHeads:[],
      }
  },
  methods:{
      async addExpense(){
          for(const ed of JSON.parse(this.expenseHead.fields)){
              if(this.expenseDataTmp[ed.name]==undefined || this.expenseDataTmp[ed.name]==null || this.expenseDataTmp[ed.name] == ""){
                this.presentAlert(ed.name);
                return;
              }
          }
          if(this.expenseDataTmp["TotalAmount"]==undefined || this.expenseDataTmp["TotalAmount"]==null || this.expenseDataTmp["TotalAmount"] == ""){
            this.presentAlert("Total Amount");
            return;
          }
          for(const ed of JSON.parse(this.expenseHead.fields)){
              if(ed.type=="Date"){
                  const dt= new Date(this.expenseDataTmp[ed.name]);
                //   this.expenseDataTmp[ed.name] = dt.getDay()+"-"+dt.getMonth()+"-"+dt.getFullYear();
                  this.expenseDataTmp[ed.name] = dt.toLocaleDateString();
              }
          }
          const visualData=this.expenseDataTmp;
          visualData.expenseName=this.expenseHead.name;
          this.visualExpenseData.push(visualData);
          this.expenseDataTmp["expense_head_id"]=this.expenseHead.id;
          this.expenseDataTmp["attachments"]=this.attachmentTmp;
          this.expenseData.push(this.expenseDataTmp);
          this.expenseDataTmp={};
          this.attachmentTmp=[];
          this.isModalOpen=false;
          this.expenseHead="";
      },
      async save(){
        if(this.billType=="" || this.billType==null){
            this.presentAlert("Bill Type");
            return;
        }
        if(this.date=="" || this.date==null){
            this.presentAlert("Date");
            return;
        }
        if(this.expenseData.length==0){
            this.presentAlert("Expense Data");
            return;
        }
        const data={
            'bill_type':this.billType,
            'date':this.date,
            'expense_data':this.expenseData,
        };
        data['username'] = window.localStorage.username,
        data['password'] = window.localStorage.password,
      this.$http.post('submitBill',data).then(response=>{
        if(response.status==200){
            this.billType=null;
            this.date=null;
            this.expenseData=[];
            this.visualExpenseData=[];
          this.presentResponseAlert('Success',response.data.msg);
        }
      });      
    },
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
    async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message+" is required",
          buttons: ['OK'],
        });
      await alert.present();

    },
    async takePicture() {
      const image = await Camera.getPhoto({
      quality: 90,
      height:720,
      allowEditing: false,
      resultType: CameraResultType.Base64
      });
    this.attachmentTmp.push(image.base64String);

    },
  }
}
</script>

<style scoped>

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
</style>